import { adminRoute } from './adminRoute'
import { webRoute } from './webRoute'
import { defaultRoute } from './defaultRoute'
import { partnerRoute } from './partnerRoute'
import { hostRoute } from './hostRoute'
import { serviceRoute } from './serviceProviderRoute'

const routes = []

export default routes.concat(adminRoute, webRoute, defaultRoute, partnerRoute, serviceRoute, hostRoute)
